import { renderBanner } from '../Common/Common';
export function Banner() {
  return <div className='home-page'>{renderBanner()}</div>;
}
